import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Input } from './ui/input';
import { ExerciseDemo } from './ExerciseDemo';

export const ExerciseMedia = ({ ex }) => {
  if (ex.animation_url) return <ExerciseDemo exercise={ex} />;
  const url = ex.video_url || ex.image_url;
  if (!url) return null;
  if (/\.(mp4|webm)(\?|$)/i.test(url)) {
    return <video src={url} autoPlay loop muted playsInline className="w-full max-h-64 object-contain rounded-3xl bg-black" />;
  }
  if (/\.(gif|png|jpe?g|webp)(\?|$)/i.test(url)) {
    return <img src={url} alt={ex.name} className="w-full max-h-64 object-contain rounded-3xl bg-white" />;
  }
  return (
    <a href={url} target="_blank" rel="noopener noreferrer"
      className="inline-flex items-center gap-2 text-[#C9A84C] text-sm px-4 py-2 rounded-full border border-[#C9A84C]/30">
      <ExternalLink className="w-4 h-4" /> Zobacz wideo
    </a>
  );
};

export const PlanChips = ({ ex }) => (
  <div className="flex flex-wrap gap-2 text-sm">
    {ex.reps && <span className="chip">{/^[\d\s-]+$/.test(ex.reps) ? `${ex.reps} powt.` : ex.reps}</span>}
    {ex.weight != null && <span className="chip">{ex.weight} kg</span>}
    {ex.tempo && <span className="chip">Tempo {ex.tempo}</span>}
    {ex.rir != null && <span className="chip">RIR {ex.rir}</span>}
    {ex.rpe != null && <span className="chip">RPE {ex.rpe}</span>}
  </div>
);

export const SetInputs = ({ value, onChange, compact }) => (
  <div className={`grid grid-cols-2 gap-3 ${compact ? '' : 'max-w-sm'}`}>
    <div>
      <label className="label-text text-[var(--text-muted)] text-[0.6rem] mb-1.5 block">{compact ? 'POWT.' : 'POWTÓRZENIA'}</label>
      <Input inputMode="numeric" value={value?.reps ?? ''} onChange={e => onChange({ ...value, reps: e.target.value })}
        className="bg-[var(--glass-soft)] border-[var(--glass-soft-border)] rounded-2xl text-[var(--text-primary)] h-12 text-center text-lg font-bold" />
    </div>
    <div>
      <label className="label-text text-[var(--text-muted)] text-[0.6rem] mb-1.5 block">{compact ? 'KG' : 'CIĘŻAR (KG)'}</label>
      <Input inputMode="decimal" value={value?.weight ?? ''} onChange={e => onChange({ ...value, weight: e.target.value })}
        className="bg-[var(--glass-soft)] border-[var(--glass-soft-border)] rounded-2xl text-[var(--text-primary)] h-12 text-center text-lg font-bold" />
    </div>
  </div>
);
